import * as React from 'react';
import * as mobxReact from 'mobx-react';
import { injectIntl, IntlShape } from 'react-intl';
import DefaultButton from '../../../../global/default-button/default-button';
import { CommonModal } from '../../../../global/modal/common/common-modal';
import { DefaultCloseModalButton } from '../../../../global/modal/common/common-close-modal-buttons';
import { MeetingsListViewModel } from '../meetings-list.viewmodel';
import { AssignRoomFormPresentation } from './_assign-room-form/assign-room-form.presentation';
import { ASSIGN_ROOM_LABEL_TEXT } from './_assign-room-form/assign-room-form.texts';

interface IProps {
    vm: MeetingsListViewModel;
    intl: IntlShape;
}

const AssignRoomModal = injectIntl(mobxReact.observer((props: IProps) => {
    const { intl, vm } = props;

    if (!vm) return null;

    return (
        <CommonModal
            title={intl.formatMessage(ASSIGN_ROOM_LABEL_TEXT)}
            isOpen={vm.getIsAssignRoomsFormShown()}
            onRequestClose={vm.hideAndResetAssignRoomsForm}
            footer={(
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultButton
                        text={intl.formatMessage(ASSIGN_ROOM_LABEL_TEXT)}
                        modifier={['fat', 'confirm-safe']}
                        onClick={vm.startAssignRoomsJob}
                    />
                    <DefaultCloseModalButton />
                </div>
            )}
        >
            <AssignRoomFormPresentation vm={vm} />
        </CommonModal>
    );
}));

export { AssignRoomModal };
